// icons
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faFootballBall } from '@fortawesome/pro-light-svg-icons/faFootballBall';
import { faFootballHelmet } from '@fortawesome/pro-light-svg-icons/faFootballHelmet';
import { faBasketballHoop } from '@fortawesome/pro-light-svg-icons/faBasketballHoop';
import { faBasketballBall } from '@fortawesome/pro-light-svg-icons/faBasketballBall';
import { faBaseballBall } from '@fortawesome/pro-light-svg-icons/faBaseballBall';
import { faGolfBall } from '@fortawesome/pro-light-svg-icons/faGolfBall';
import { faBoxingGlove } from '@fortawesome/pro-light-svg-icons/faBoxingGlove';
import { faHockeyPuck } from '@fortawesome/pro-light-svg-icons/faHockeyPuck';
import { faGlobeAmericas } from '@fortawesome/pro-light-svg-icons/faGlobeAmericas';
import { faTableTennisPaddleBall } from '@fortawesome/pro-light-svg-icons/faTableTennisPaddleBall';
import { faFutbol } from '@fortawesome/pro-light-svg-icons/faFutbol';
import { faPlusCircle } from '@fortawesome/pro-light-svg-icons/faPlusCircle';
import { faShirt } from '@fortawesome/pro-light-svg-icons/faShirt';

export function getFaSportIcon(sport) {
  const sports = {
    basketball:
      sport.name === 'NBA' || (sport.league?.includes('NBA') && !sport.league?.includes('WNBA'))
        ? faBasketballBall
        : faBasketballHoop,
    baseball: faBaseballBall,
    golf: faGolfBall,
    fighting: faBoxingGlove,
    hockey: faHockeyPuck,
    politics: faGlobeAmericas,
    tennis: faTableTennisPaddleBall, // check
    soccer: faFutbol,
    props: faShirt,
    football:
      sport.name === 'NFL' || sport.league?.includes('NFL')
        ? faFootballBall
        : faFootballHelmet,
    //  racing: faFlagCheckered,
    custom: faPlusCircle,
  };
  return sports[sport.sport] || faPlusCircle;
}
